import AzureExtractFeed from './AzureExtractFeed'

export default function GamingSessionsFeed() {
  return <AzureExtractFeed feedId="sessions" />
}
